import { render, staticRenderFns } from "./SubscriptionItems.vue?vue&type=template&id=ec8035ce&scoped=true"
import script from "./SubscriptionItems.vue?vue&type=script&lang=js"
export * from "./SubscriptionItems.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionItems.vue?vue&type=style&index=0&id=ec8035ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec8035ce",
  null
  
)

export default component.exports